var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.38 77.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-0.81 -7.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M35.867,75.367a2.514,2.514,0,0,0,3.372-1.119l18-35.875a2.513,2.513,0,0,0-4.492-2.254l-18,35.875A2.512,2.512,0,0,0,35.867,75.367Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M31.159,64.775a2.513,2.513,0,0,0,3.28-3.809l-6.426-5.533L34.437,49.9a2.512,2.512,0,1,0-3.277-3.807l-8.637,7.436a2.514,2.514,0,0,0,0,3.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M58.623,64.512a2.516,2.516,0,0,0,3.543.264L70.8,57.338a2.517,2.517,0,0,0,0-3.808l-8.635-7.436A2.512,2.512,0,1,0,58.887,49.9l6.424,5.533-6.424,5.533A2.514,2.514,0,0,0,58.623,64.512Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M37.816,22.107h.271a2.513,2.513,0,1,0,0-5.026h-.271a2.513,2.513,0,0,0,0,5.026Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M26.692,22.107h.271a2.513,2.513,0,1,0,0-5.026h-.271a2.513,2.513,0,1,0,0,5.026Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M15.568,22.107h.271a2.513,2.513,0,1,0,0-5.026h-.271a2.513,2.513,0,1,0,0,5.026Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M87.676,7.357H3.323A2.513,2.513,0,0,0,.81,9.869V82.685A2.513,2.513,0,0,0,3.323,85.2H79.989a10.213,10.213,0,0,0,10.2-10.2V9.869A2.514,2.514,0,0,0,87.676,7.357ZM85.164,74.994a5.183,5.183,0,0,1-5.176,5.178H5.835V31.836H85.164Zm0-48.185H5.835V12.383H85.164Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectBlack);
export default __webpack_public_path__ + "static/media/inspectBlack.b25225be6970456b14e31413c4315dc3.svg";
export { ForwardRef as ReactComponent };